module.exports = __webpack_public_path__ + "static/media/lady-mentor.a12c102c.jpg";